import axios from 'axios';
import ProjectConfig from 'ProjectConfig';
import qs from 'query-string';
import {
  mobileVendor,
  mobileModel,
  osName,
  browserName,
  osVersion,
  fullBrowserVersion
} from 'react-device-detect';

const API_GATEWAY = ProjectConfig.API_GATEWAY;
const PACKAGE_VERSION = ProjectConfig.version;


export const isFormTokenValid = (token, emailVerifyType) => async dispatch => {
  try {

    const url = qs.stringifyUrl({
      url: `${API_GATEWAY}/users/status-change/check/form`,
      query: { code: token, emailVerifyType },
    });

    await axios.get(url);
    return true;

  } catch (error) {
    return false;
  }
};


export const checkCoupon = () => async dispatch => {
  try {
    
    const [resIddaa, resSportoto, resTjk, raffle, changeCard] = await Promise.all([
      axios.get(`${API_GATEWAY}/iddaa/coupons/check/ongoing`),
      axios.get(`${API_GATEWAY}/sportoto/coupons/check/ongoing`),
      axios.get(`${API_GATEWAY}/mobile/tjk/coupon/check/ongoing`),
      axios.get(`${API_GATEWAY}/mobile/digital-lottery/coupons/check/ongoing?gameType=RAFFLE`),
      axios.get(`${API_GATEWAY}/mobile/digital-lottery/coupons/check/ongoing?gameType=CHANCE_CARD`),
    ]);

    if (resIddaa.data || resSportoto.data || resTjk.data.body || raffle.data || changeCard.data) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const checkBalance = () => async dispatch => {

  try {

    const res = await axios.get(`${API_GATEWAY}/account-balance`);
    return res.data;

  } catch (error) {
    //console.log('error: ', error);
  }

};


export const getAllReasons = () => async dispatch => {

  try {

    const res = await axios.get(`${API_GATEWAY}/bip-ticket-v2/reasons`);
    return res.data;

  } catch (error) {
    //console.log('error: ', error);
  }

};


export const isEmailVerified = (email, code) => async dispatch => {
  try {
    const url = qs.stringifyUrl({
      url: `${API_GATEWAY}/users/status-change/check/email-code`,
      query: { email, code },
    });
 
    await axios.get(url);
    return true;
 
  } catch (err) {
    return false;
  }
};
 

export const emailVerifyOrUpdate = (email, userId, cb) => async dispatch => {
  try {
  
    const url = qs.stringifyUrl({
      url: '/users/status-change/send/email-code',
      query: { email, userId }
    });
  
    const res = await axios.post(url);
    return res.data?.code;
  
  } catch (err) {
    //console.log('err: ', err);
  }
};

export const postSuspendForm = formData => async dispatch => {
  const formDataWithClientDetails = {
    ...formData,
    clientDetails: {
      appVersion: PACKAGE_VERSION,
      os: `${osName} ${osVersion}`,
      device: `${mobileVendor} ${mobileModel}`,
      name: `${browserName} ${fullBrowserVersion}`
    }
  };

  try {
    await axios({
      url: `${API_GATEWAY}/bip-ticket-v2/frozen/form`,
      method: 'POST',
      data: formDataWithClientDetails,
    });

    return true;
  } catch (e) {
    return false;
  }
};

export const postCancellationForm = formData => async dispatch => {
  const formDataWithClientDetails = {
    ...formData,
    clientDetails: {
      appVersion: PACKAGE_VERSION,
      os: `${osName} ${osVersion}`,
      device: `${mobileVendor} ${mobileModel}`,
      name: `${browserName} ${fullBrowserVersion}`
    }
  };

  try {
    const res = await axios({
      url: `${API_GATEWAY}/bip-ticket-v2/cancellation/form`,
      method: 'POST',
      data: formDataWithClientDetails,
    });

    return { ...res.data, isSuccess: true };
  } catch (e) {
    return { isSuccess: false };
  }
};
